import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Phone } from 'lucide-react';
export function Services() {
  useDocumentMeta('Firearm Services & In-Store Support | Kjergaard Sports', 'Get practical in-person help, firearm selection guidance, scope installation, and in-store support at Kjergaard Sports in Lake Benton, Minnesota.');
  const services = ['Firearm selection help', 'Scope/accessory installation questions', 'Gunsmithing / repair support if currently available', 'NFA / Form 4 in-store support if currently available', 'Transfers and regulated services handled in accordance with applicable laws'];
  return <div data-id="element-523">
      <PageHero title="Services & In-Store Support" image="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/services-gunsmithing-workshop.jpg" alt="Gunsmithing workshop at Kjergaard Sports — lathe and shop tools" data-id="element-524" />

      <section className="py-20 bg-brand-offwhite" data-id="element-525">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-526">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-527">
            <div data-id="element-528">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-529">
                Real Help from Real People
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-530">
                At Kjergaard Sports, we believe that buying a firearm or
                outfitting for a hunt requires more than just a checkout button.
                We provide practical, in-person support to ensure you get the
                right equipment and understand how to use it safely.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-531">
                <h3 className="font-serif text-xl mb-4" data-id="element-532">
                  In-Store Services Include:
                </h3>
                <ul className="space-y-4" data-id="element-533">
                  {services.map((item, index) => <li key={index} className="flex items-start" data-id="element-534">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-535" />
                      <span className="text-brand-charcoal/90" data-id="element-536">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-brand-cream border-l-4 border-brand-leather p-6 mb-8" data-id="element-537">
                <p className="text-brand-charcoal/90 text-sm leading-relaxed" data-id="element-538">
                  <strong data-id="element-539">Note:</strong> All firearm-related sales, transfers,
                  and regulated services are handled strictly in-store and in
                  accordance with applicable federal, state, and local laws.
                </p>
              </div>

              <a href="tel:507-368-4696" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-540">
                <Phone className="w-5 h-5 mr-2" data-id="element-541" />
                Call the Store with Questions
              </a>
            </div>

            <div data-id="element-542">
              <img src="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/services-gunsmithing-workshop.jpg" alt="In-store service at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-543" />
            </div>
          </div>
        </div>
      </section>
    </div>;
}